const QuestionCategories = [
  { id: 1, name: 'Stirling — Positive Emotional State' },
  { id: 2, name: 'Stirling — Positive Outlook' },
  { id: 3, name: 'Stirling — Social Desirability' },
  { id: 4, name: 'WMfS — Emotion regulation' },
  { id: 5, name: 'WMfS — Coping' },
  { id: 6, name: 'WMfS — Empowerment and problem solving' },
  { id: 7, name: 'WMfS — Emotional difficulties' },
  { id: 8, name: 'WMfS — Behavioural difficulties' },
  { id: 9, name: 'WMfS — Psychological wellbeing' },
  { id: 10, name: 'WMfS — Stress' },
  { id: 11, name: 'WMfS — Relationships with parents and carers' },
  { id: 12, name: 'WMfS — Relationships with staff' },
  { id: 13, name: 'WMfS — Relationships with peers' },
  { id: 14, name: 'WMfS — Loneliness' },
  { id: 15, name: 'WMfS — Peer Pressure' },
  { id: 16, name: 'WMfS — School experience' },
  { id: 17, name: 'WMfS — Bullying' },
  { id: 18, name: 'WMfS — Peer support' },
  { id: 19, name: 'WMfS — Family support' },
  { id: 20, name: 'WMfS — Support at school' },
  { id: 21, name: 'SDQ — Emotional Problems' },
  { id: 22, name: 'SDQ — Conduct problems' },
  { id: 23, name: 'SDQ — Hyperactivity' },
  { id: 24, name: 'SDQ — Peer Problems' },
  { id: 25, name: 'SDQ — Prosocial' },
  { id: 26, name: 'CYRM — Resilience' },
  { id: 27, name: 'MDSLSS — Friends' },
  { id: 28, name: 'MDSLSS — Self' },
  { id: 29, name: 'MDSLSS — School' },
  { id: 30, name: 'MDSLSS — Family' },
  { id: 31, name: 'MDSLSS — Living' },
  { id: 32, name: 'SLSS — Life Satisfaction' },
  { id: 33, name: 'WHO-5' },
  { id: 34, name: 'YP-CORE-10' },
  { id: 35, name: 'Me and My Feelings — Behavioural' },
  { id: 36, name: 'Me and My Feelings — Emotional' },
]

export default class QuestionCategory {
  static getQuestionCategoryFromId(id) {
    return QuestionCategories.find(category => category.id === id) || null
  }
}
